export default __webpack_public_path__ + "static/media/Film_Anna Fąfara Iskra.71969440.mov";